// Присутствие: чистые правила без сети. Кто здесь — presence-канал; что делает — broadcast `activity`, у которого нет
// ни повторов, ни сверки: потерянное «я отпустил» висело бы рамкой до перезагрузки. Поэтому своё состояние уходит
// целиком раз в HEARTBEAT_MS, а чужое считается устаревшим, если от человека не было пакетов дольше двух тактов.
export const HEARTBEAT_MS = 10_000;

/** Активность человека устарела: пакетов от него не было дольше двух тактов heartbeat. */
export const stalePresence = (now: number, lastSeen: number, heartbeatMs = HEARTBEAT_MS): boolean => now - lastSeen > 2 * heartbeatMs;

/** Пауза перед следующей попыткой переподписки: 2 → 4 → 8 → 10 с, после успеха снова 2. */
export const RECONNECT_MIN_MS = 2_000;
export const RECONNECT_MAX_MS = 10_000;
export const nextReconnectDelay = (prev: number): number => Math.min(RECONNECT_MAX_MS, prev * 2);
// пауза сбрасывается в минимум только после стольких секунд стабильного канала: дёргающийся канал иначе никогда её не растит
export const RECONNECT_STABLE_MS = 30_000;
